import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {WMSContext} from "../../context/WMSContext";
import {FormattedMessage} from "react-intl";
import CustomButton from "../../../../components/CustomButton";
import {Card, CardContent, FormControlLabel, Grid, Radio, RadioGroup} from "@mui/material";
import {grey300, greyishBlue500, sidebarColor} from "../../../../assets/jss/main";
import BeatLoaderRegular from "../../../../components/loaders/BeatLoaderRegular";
import {getWMSTrolleyForPicking} from "../../../../api/wms/wmsContainers/wmsContainers";
import RightDrawer from "../../../../components/WMS/Mobile/RightDrawer";
import RightDrawerDesktop from "../../../../components/WMS/Desktop/RightDrawerDesktop";

ManualTrolleyChoice.propTypes = {
    handleTrolleyChoice: PropTypes.func.isRequired
};

function ManualTrolleyChoice({handleTrolleyChoice, handleClose}) {
    const {currentInventory, isMobile, currentMember} = useContext(WMSContext);

    const [loading, setLoading] = useState(true)
    const [containers, setContainers] = useState()
    const [selectedContainer, setSelectedContainer] = useState()

    const handleChange = (event) => {
        setSelectedContainer(event.target.value)
    }

    useEffect(() => {
        if (selectedContainer) {
            return;
        }

        if (!currentInventory) {
            return;
        }

        getWMSTrolleyForPicking(currentInventory.id).then((response) => {
            response = response.filter(container => null === container.member || container.member === currentMember['@id'])
            setContainers(response)
        }).finally(() => {
            setLoading(false)
        })
    }, [currentInventory]);

    if (loading && !selectedContainer) {
        return (
            <Grid item sx={{margin: "auto"}}>
                <BeatLoaderRegular loading={true} size={15}/>
            </Grid>
        )
    }

    function displayContent (){
        return (
            <Grid
                container
                direction={"column"}
                sx={{height: "100%"}}
                justifyContent={"space-between"}
            >
                <Grid
                    container
                    direction={"column"}
                    flex={1}
                >
                    {containers.length === 0 && (
                        <span style={{color: greyishBlue500}}>
                            <FormattedMessage id={"wms.myPickingMissions.manualTrolleyChoiceDrawer.noContainers"}/>
                        </span>
                    )}
                    <RadioGroup
                        onChange={handleChange}
                        value={selectedContainer}
                    >
                        {containers && containers.length > 0 && containers.map((container) => (
                            <Card>
                                <CardContent style={{padding: 0, backgroundColor: sidebarColor}}>
                                    <FormControlLabel
                                        value={container.codebar}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row-reverse",
                                            justifyContent: "space-between",
                                            margin: 0,
                                            padding: "16px",
                                            ':hover': {
                                                backgroundColor: grey300,
                                            },
                                        }}
                                        control={<Radio/>}
                                        label={container.name}
                                    />
                                </CardContent>
                            </Card>
                        ))}
                    </RadioGroup>
                </Grid>
            </Grid>
        );
    }

    if (isMobile) {
        return (
            <RightDrawer
                open={true}
                handleClose={handleClose}
                headerCenterContent={
                    <b>
                        <FormattedMessage id={"wms.myPickingMissions.manualTrolleyChoiceDrawer.subtitle"}/>
                    </b>
                }
                footer={
                    <CustomButton
                        fullWidth
                        disabled={!selectedContainer || loading}
                        loading={loading}
                        onClick={() => {
                            setLoading(true)
                            handleTrolleyChoice(selectedContainer).then(() => {
                                setLoading(false)
                            })
                        }}
                    >
                        <FormattedMessage id={"wms.myPickingMissions.manualTrolleyChoiceDrawer.button"}/>
                    </CustomButton>
                }
            >
                {displayContent()}
            </RightDrawer>
        )
    }

    return (
        <RightDrawerDesktop
            open={true}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.myPickingMissions.manualTrolleyChoiceDrawer.title"}/>}
            subtitle={<FormattedMessage id={"wms.myPickingMissions.manualTrolleyChoiceDrawer.subtitle"}/>}
            disablePortal
            customHeaderPadding={"0 0 8px 40px"}
            footer={
                <CustomButton
                    fullWidth
                    disabled={!selectedContainer || loading}
                    loading={loading}
                    onClick={() => {
                        setLoading(true)
                        handleTrolleyChoice(selectedContainer).then(() => {
                            setLoading(false)
                        })
                    }}
                >
                    <FormattedMessage id={"wms.myPickingMissions.manualTrolleyChoiceDrawer.button"}/>
                </CustomButton>
            }
        >
            {displayContent()}
        </RightDrawerDesktop>
    )
}


export default ManualTrolleyChoice;